import { render, staticRenderFns } from "./siteUploadFile.vue?vue&type=template&id=07487e53&scoped=true"
import script from "./siteUploadFile.vue?vue&type=script&lang=js"
export * from "./siteUploadFile.vue?vue&type=script&lang=js"
import style0 from "./siteUploadFile.vue?vue&type=style&index=0&id=07487e53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07487e53",
  null
  
)

export default component.exports